module.exports = __webpack_public_path__ + "img/Illustration-problem@3x.50b37da.png";